module.exports = __webpack_public_path__ + "static/media/7.f1760ba0.png";